import { Pipe, PipeTransform } from "@angular/core";

const PADDING = "000000";

@Pipe({ name: "myCurrency" })
export class CurrencyPipe implements PipeTransform {

  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  transform(value: number | string | undefined, currencyLabel: string = "", fractionSize: number = 2,): string {
    if (value || value === 0) {
      let [integer, fraction = ""] = value.toString()
        .split(this.DECIMAL_SEPARATOR);

      fraction = fractionSize > 0
        ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
        : "";

      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

      return `${integer}${fraction} ${currencyLabel}`;
    }
    else {
      return "-"
    }
  }
}
